import { useEffect, useState } from "react";
import api from "@/lib/api";

// A CODE IS NEVER CUT (his rule, 21 Oct). The app offers words that fit whole; he taps one, or types his own,
// and sees the exact code before Create. A word that doesn't fit is refused in plain words, never shortened.
export function CodeWordPicker({ name, type, parentId, onResolved }) {
  const [opts, setOpts] = useState(null);
  const [word, setWord] = useState("");
  const [own, setOwn] = useState(false);
  const [typed, setTyped] = useState("");

  useEffect(() => { setWord(""); setOwn(false); setTyped(""); }, [type, parentId]);

  const asked = own ? typed : word;
  useEffect(() => {
    if (!name.trim() && !asked) { setOpts(null); onResolved(null); return undefined; }
    const t = setTimeout(() => {
      api.get("/locations/code-options", { params: { name, type, parent_id: parentId || undefined, word: asked || undefined } })
        .then(({ data }) => {
          setOpts(data);
          const pick = data.chosen || (!asked && data.options[0]) || null;
          if (!asked && pick) setWord(pick.word);
          onResolved(data.error ? null : pick);
        })
        .catch(() => { setOpts(null); onResolved(null); });
    }, 250);
    return () => clearTimeout(t);
  }, [name, type, parentId, asked]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!opts) return null;
  const shown = opts.chosen || (!own && opts.options.find((o) => o.word === word)) || null;
  return (
    <div data-testid="code-word-picker" className="space-y-2">
      <div className="text-xs font-bold uppercase tracking-wider text-slate-500">
        {type === "zone" ? "Zone code" : type === "site" ? "Property code" : "Code word"} — tap one ({opts.rule.replace(/^A (zone code|code word|property code) is /, "")})
      </div>
      <div className="flex flex-wrap gap-1.5">
        {opts.options.map((o) => (
          <button key={o.word} type="button" data-testid={`code-word-opt-${o.word}`}
            onClick={() => { setOwn(false); setWord(o.word); }}
            className={`rounded-full border px-3 py-1.5 text-sm font-mono transition-colors ${!own && word === o.word ? "border-sky-600 bg-sky-50 text-sky-800 font-bold" : "border-slate-300 bg-white text-slate-700 hover:border-sky-400"}`}>
            {o.word}
          </button>
        ))}
        <button type="button" data-testid="code-word-own-toggle" onClick={() => setOwn(true)}
          className={`rounded-full border border-dashed px-3 py-1.5 text-sm transition-colors ${own ? "border-sky-600 text-sky-800" : "border-slate-300 text-slate-600 hover:border-sky-400"}`}>
          Type my own…
        </button>
      </div>
      {!opts.options.length && !own && (
        <p data-testid="code-word-none" className="text-[12px] text-amber-800">
          No word in this name fits whole — tap <b>Type my own…</b>{type === "zone" ? " (for example WHSE)" : ""}.
        </p>
      )}
      {own && (
        <input data-testid="code-word-input" autoFocus value={typed} onChange={(e) => setTyped(e.target.value.toUpperCase())}
          className="w-40 rounded-lg border border-slate-300 px-3 py-2 font-mono text-sm uppercase" placeholder={type === "zone" ? "e.g. WHSE" : type === "site" ? "e.g. ROY" : "e.g. SHELF"} />
      )}
      {opts.error && <p data-testid="code-word-error" className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-[12px] text-[#B01E28]">{opts.error}</p>}
      {shown && !opts.error && (
        <div data-testid="new-place-code" className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700">
          Its code will be <b className="font-mono">{shown.code}</b> — it never changes.
          {type === "zone" && (
            <div data-testid="new-zone-label-preview" className="mt-1 text-[12px] text-slate-500">
              Labels in this zone will read <span className="font-mono font-bold text-slate-800">{shown.code}</span> over <span className="font-mono font-bold text-slate-800">R1-B1-A</span>.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
